module.exports = __webpack_public_path__ + "img/refund-policy-ilustra.ab47c865.png";